<template>
  <div class="login-wrapper">    
  </div>
</template>

<script>
import { setCookie,getCookie } from '../common/common.js'
export default {
    data(){
        return {
            
        }
    },
    mounted () {
        var queryData = this.$route.query
        console.log(this.$route)
        console.log(window.location.href)
        var redirect_uri = TmeGetUrlParam("redirect_uri")
        console.log(redirect_uri)
        // var urlMd5 = md5(redirect_uri)
        // var sessionKey = getCookie("session_key")
        // var hasBind = getCookie("has_bind")
        // var finalUrl = getCookie("login_url")
        var sessionKey = queryData.session_key
        // if (!sessionKey) {
        //     sessionKey = getCookie('session_key',sessionKey)
        // }
        // var hasBind = queryData.has_bind
        // var finalUrl = queryData.login_url
        //  alert(hasBind);
        //  alert(sessionKey);
        // if(finalUrl != null && finalUrl != "") {
        //     setCookie(urlMd5,finalUrl,7*24*60)
        //     if(sessionKey != null && sessionKey != ""){
        //         window.location.href = finalUrl;
        //     }
        // }


        if(sessionKey != null && sessionKey != "") {
            
            this.$router.push('/bind?session_key='+sessionKey);
            return
        }

        // var loginUrl = getCookie(urlMd5)
        // if (loginUrl != null && loginUrl != "") {
        //     if(sessionKey != null && sessionKey != "" ){
        //         window.location.href = loginUrl;
        //     }
        // }
        if(!sessionKey){
            var baseUrl = "/institute/h5-login/#/bind"
            if(!redirect_uri || redirect_uri == null || redirect_uri == "" || redirect_uri == "undefined") {
                redirect_uri = ""
            }
            
            console.log(baseUrl)
            var appId = process.env.APPID
            var url = process.env.REDIRECT_URI + process.env.REDIRECT_PATH + '?redirect_source=' + encodeURIComponent(baseUrl) + '&redirect_final=' + encodeURIComponent(redirect_uri)
            var redirectUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appId+'&redirect_uri='+encodeURIComponent(url)+'&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'
            console.log(redirectUrl)
            window.location.href = redirectUrl

        }
        //获取当前地址参数
        //获取当前地址参数
        function TmeGetUrlParam(paraName) {
                var url = decodeURIComponent(document.location.toString());
                var arrObj = url.split("?");

                if (arrObj.length > 1) {
                    var arrPara = arrObj[1].split("&");
                    var arr;

                    for (var i = 0; i < arrPara.length; i++) {
                    arr = arrPara[i].split("=");

                    if (arr != null && arr[0] == paraName) {
                        return decodeURIComponent(arr[1]);
                    }
                    }
                    return "";
                }
                else {
                    return "";
                }
        }

	},
}
</script>


// WEBPACK FOOTER //
// src/pages/login.vue